import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SpinnerService } from '../spinner/spinner.service';
import { ToastService } from '../toast/toast.service';
import { IVisit, Visit } from '../../models/visit.model';
import { environment } from '../../../../environments/environment.production';
import { IServerResponse, ServerResponse } from '../../models/server-response.model';

@Injectable({
  providedIn: 'root'
})
export class VisitService {

  constructor(
    private http: HttpClient,
    public spinnerService: SpinnerService,
    public toastService: ToastService
  ) { }

  /*
   ██████╗ ███████╗████████╗
  ██╔════╝ ██╔════╝╚══██╔══╝
  ██║  ███╗█████╗     ██║
  ██║   ██║██╔══╝     ██║
  ╚██████╔╝███████╗   ██║
   ╚═════╝ ╚══════╝   ╚═╝

  */
  async get(
    uid: string
  ): Promise<Visit | undefined> {

    let currentVisit: Visit | undefined;

    const urlApi = `${environment.apiUrl}/visits/${uid}`;

    try {

      const response = await new Promise<ServerResponse<{visit: IVisit}>>(
        (resolve, reject) => {
          this.http.get<IServerResponse<{visit: IVisit}>>(
            urlApi,
            {
              headers: {
                "content-type": "application/json",
              }
            }
          ).subscribe({
            next: (
                response: IServerResponse<{visit: IVisit}>
              ) => resolve(
                new ServerResponse(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 200) {

        currentVisit = new Visit(response.data!.visit);

      } else {

        this.toastService.show(
          {
            header: 'Error de servidor',
            body: `${response.message}`,
            classname: 'bg-danger text-white'
          }
        );

      }

    } catch(error) {
      console.log(error);

      this.toastService.show(
        {
          header: 'Error',
          body: `${error}`,
          classname: 'bg-danger text-white'
        }
      );
      
    }

    this.spinnerService.loading = false;
    this.spinnerService.message = '';

    return currentVisit;

  }
}
